import { toGregorian, toJalali } from '../../../utils/dateUtils';

/** مقدار PersianDatePicker (DateObject / Date / رشته شمسی) → YYYY-MM-DD میلادی برای API نسخه ۲ */
export const toApiDate = (value) => {
  if (!value) return null;
  if (typeof value?.toDate === 'function') return toGregorian(value.toDate());
  if (value instanceof Date) return toGregorian(value);
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) return value.slice(0, 10);
  return toGregorian(value);
};

export const fmtDate = (value) => (value ? toJalali(value) || value : '—');

/** «YYYY-MM-DD HH:mm:ss» (بدون T) را toJalali فقط به‌عنوان تاریخ می‌خواند؛ برای حفظ ساعت به ISO محلی تبدیل می‌شود */
const withTime = (value) =>
  typeof value === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(value) ? value.replace(' ', 'T') : value;

export const fmtDateTime = (value) => (value ? toJalali(withTime(value), 'jYYYY/jMM/jDD HH:mm') || value : '—');

/** پاسخ API نسخه ۲: {status, data, ...} */
export const v2Data = (res) => (res && Object.prototype.hasOwnProperty.call(res, 'data') ? res.data : res);

/** تاریخ میلادی API (۲۰۲۶-۱۰-۲۱ یا ISO با ساعت/منطقه‌ی زمانی) → مقدار «جلالی» برای PersianDatePicker؛ ساعت و منطقه‌ی زمانی نادیده گرفته می‌شود. */
export const apiDateToPicker = (value) => {
  if (!value) return null;
  const text = String(value);
  return /^\d{4}-\d{2}-\d{2}/.test(text) ? toJalali(text.slice(0, 10)) : text;
};
